export default __webpack_public_path__ + "files/DownwardTrendIcon-72bc7bbc4ec1ecffb0adc7c3c73a4f41.png";